import React, { useState, useEffect } from 'react';
import API from 'config/ApiConfig';
import { Mosaic } from 'react-loading-indicators';
export default function CreateRekap() {
  const [formData, setFormData] = useState({
    siswa_id: '',
    mata_pelajaran: '',
    waktu_pembelajaran: '',
    jam: '',
    durasi: '',
    feedback: '',
    ulasan: '',
    tentor_id: ''
  });
  const [siswaData, setSiswaData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  // const API_BASE_URL = 'http://localhost:5000/api/tentor';
  const API_BASE_URL = API.API_TENTOR;
  const JWT_TOKEN = localStorage.getItem('authToken');
  const tentorId = localStorage.getItem('tentorId');

  function getAuthHeaders() {
    return {
      'Authorization': `Bearer ${JWT_TOKEN}`,
      'Content-Type': 'application/json',
    };
  }

  useEffect(() => {
    const fetchSiswaData = async () => {
      try {
        // Fetching siswa data by tentorId
        const siswaResponse = await fetch(`${API_BASE_URL}/siswa/by-tentor-id/${tentorId}`, {
          method: 'GET',
          headers: getAuthHeaders(),
        });
        if (!siswaResponse.ok) {
          throw new Error(`HTTP error! Status: ${siswaResponse.status}`);
        }
        const siswaData = await siswaResponse.json();
        setSiswaData(siswaData);
      } catch (error) {
        setError(error.message);
        console.error('Error fetching siswa data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchSiswaData();
  }, [tentorId]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      console.log('Tentor ID yang dikirim:', tentorId);  // Debugging output
      const response = await fetch(`${API_BASE_URL}/rekap`, {
        method: 'POST',
        headers: getAuthHeaders(),
        body: JSON.stringify({
          siswa_id: formData.siswa_id,
          mata_pelajaran: formData.mata_pelajaran,
          waktu_pembelajaran: new Date(formData.waktu_pembelajaran).toISOString(),
          jam: formData.jam,
          durasi: formData.durasi,
          feedback: formData.feedback,
          ulasan: formData.ulasan,
          tentor_id: tentorId,
        }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      alert('Absen berhasil dibuat!');
      window.location.href = '/tentor/presensi';
    } catch (error) {
      setError(error.message);
      console.error('Error creating absen:', error);
    }
  };

  if (loading) {
    return <div className="flex m-4 justify-center items-center w-screen"><Mosaic color="#1177bc" size="large" text="Loading.." textColor="" /></div>
  }
  if (error) return <div>Error : Tampaknya terjadi error, silahkan logout kemudian login kembali yaa</div>;

  return (
    <div>
      <h3 className="font-bold uppercase text-lg text-blueGray-700 align-center m-4">Create Presensi</h3>
      {error && <p className="text-red-500 text-xs">{error}</p>}
      <form onSubmit={handleSubmit} className="space-y-4">
        {/* Siswa Dropdown */}
        <div className="bg-white p-4 rounded shadow border border-blueGray-300 mb-2">
          <label className="block font-semibold text-blueGray-600">Pilih Siswa:</label>
          <select
            name="siswa_id"
            value={formData.siswa_id}
            onChange={handleChange}
            className="w-full px-3 py-2 border border-blueGray-300 rounded"
          >
            <option value="">Pilih Siswa</option>
            {siswaData.map((siswaItem) => (
              <option key={siswaItem._id} value={siswaItem._id}>
                {siswaItem.nama}
              </option>
            ))}
          </select>
        </div>
        <div className="bg-white p-4 rounded shadow border border-blueGray-300 mb-2">
          <label className="block font-semibold text-blueGray-600">Mata Pelajaran:</label>
          <input
            type="text"
            name="mata_pelajaran"
            value={formData.mata_pelajaran}
            onChange={handleChange}
            className="w-full px-3 py-2 border border-blueGray-300 rounded"
            required
          />
        </div>
        <div className="bg-white p-4 rounded shadow border border-blueGray-300 mb-2">
          <label className="block font-semibold text-blueGray-600">Waktu Pembelajaran:</label>
          <input
            type="date"
            name="waktu_pembelajaran"
            value={formData.waktu_pembelajaran}
            onChange={handleChange}
            className="w-full px-3 py-2 border border-blueGray-300 rounded"
            required
          />
        </div>
        <div className="bg-white p-4 rounded shadow border border-blueGray-300 mb-2">
          <label className="block font-semibold text-blueGray-600">Jam:</label>
          <input
            type="text"
            name="jam"
            value={formData.jam}
            onChange={handleChange}
            className="w-full px-3 py-2 border border-blueGray-300 rounded"
          />
        </div>
        <div className="bg-white p-4 rounded shadow border border-blueGray-300 mb-2">
          <label className="block font-semibold text-blueGray-600">Durasi:</label>
          <input
            type="text"
            name="durasi"
            value={formData.durasi}
            onChange={handleChange}
            className="w-full px-3 py-2 border border-blueGray-300 rounded"
            placeholder='Masukan menit, misal 90 menit'
          />
        </div>
        <div className="bg-white p-4 rounded shadow border border-blueGray-300 mb-2">
          <label className="block font-semibold text-blueGray-600">Catatan Belajar Siswa:</label>
          <textarea
            name="feedback"
            value={formData.feedback}
            onChange={handleChange}
            className="w-full px-3 py-2 border border-blueGray-300 rounded"
            placeholder='Isi catatan belajar siswa'
          />
        </div>
        <div>
          <button
            type="submit"
            className="bg-lightBlue-500 text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none m-4 ease-linear transition-all duration-150"
          >
            Buat Presensi
          </button>
          <a href="/tentor/presensi">
            <button
              type="button"
              className="bg-red-500 text-white active:bg-red-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none m-4 ease-linear transition-all duration-150"
            >
              Cancel
            </button>
          </a>
        </div>
      </form>
    </div>
  );
}
